import { render, staticRenderFns } from "./SearchPreferencesFormSH.vue?vue&type=template&id=442b0334"
import script from "./SearchPreferencesFormSH.vue?vue&type=script&lang=js"
export * from "./SearchPreferencesFormSH.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports